import type { FC } from "react";

import dayjs from "dayjs";

import { fullMonthAndYear, shortMonthShortDayAndYear } from "@similarweb/pro-logic-components";
import { ChangeTooltip } from "@similarweb/ui-components";

import type { TimeGranularity } from "app/components/widget/widget-utilities/time-granularity";
import { timeGranularity as TimeGranularityOptions } from "app/components/widget/widget-utilities/time-granularity";
import { abbrNumberVisitsFilter } from "app/filters/ngFilters";

interface ITooltipHeaders {
    domain: string;
    traffic: string;
}

interface ITrafficShareGraphTooltipProps {
    timeGranularity: TimeGranularity;
    tooltipHeaders: ITooltipHeaders;
    points: Array<{
        x: number;
        y: number;
        series: {
            name: string;
            color: string;
        };
    }>;
}

export const TrafficShareGraphTooltip: FC<ITrafficShareGraphTooltipProps> = ({
    points,
    timeGranularity,
    tooltipHeaders,
}) => {
    const isDailyGranularity = timeGranularity === TimeGranularityOptions.daily;
    const tooltipTitleFormat = isDailyGranularity ? shortMonthShortDayAndYear : fullMonthAndYear;
    const tooltipTitleFormatter = (date: number) => dayjs.utc(date).format(tooltipTitleFormat);

    const tooltipProps = {
        header: tooltipTitleFormatter(points[0].x),
        tableHeaders: [
            { position: 0, displayName: tooltipHeaders.domain },
            {
                position: 1,
                displayName: tooltipHeaders.traffic,
            },
        ],
        showChangeColumn: false,
        tableRows: points.map((point) => {
            return {
                color: point.series.color,
                value: abbrNumberVisitsFilter()(point.y),
                displayName: point.series.name,
            };
        }),
    };

    return <ChangeTooltip {...tooltipProps} />;
};
